<div [ngClass]="deviceService.ifMobile('heading-mobile').orElse('heading')">
    <ng-content></ng-content>
</div>
